import firebase from "firebase";
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDp4-_Qho-70V-p8cHH14142viOKNV3WiQ",
  authDomain: "career-grads.firebaseapp.com",
  projectId: "career-grads",
  storageBucket: "career-grads.appspot.com",
  messagingSenderId: "253272119865",
  appId: "1:253272119865:web:217864833717d4c5bc8be8",
  measurementId: "G-C1RG9RLB9Z",
};
// Initialize Firebase
const fire = firebase.initializeApp(firebaseConfig);

export default fire;
